import { MouseEvent } from 'react';

import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { GridColumnMenuItemProps } from '@mui/x-data-grid';

import { ReactComponent as GroupIcon } from '@/assets/icons/GroupWorkRounded.svg';

import { useGeneratikTableContext } from './GeneratikTableContext';

const GeneratikTableColumnMenuGroupItem = ({ colDef, onClick }: GridColumnMenuItemProps) => {
  const ctx = useGeneratikTableContext();
  const isGroupedByColumn = ctx.groupByField === colDef.field;

  const handleClick = (event: MouseEvent<HTMLLIElement>) => {
    ctx.onGroupChange?.(isGroupedByColumn ? null : colDef.field);
    onClick(event);
  };

  const columnName = colDef.headerName ?? colDef.field;

  return (
    <MenuItem onClick={handleClick} data-testid={`column-menu-group-by-${colDef.field}`}>
      <ListItemIcon>
        <GroupIcon />
      </ListItemIcon>
      <ListItemText>
        {ctx.t(isGroupedByColumn ? 'ungroup_column' : 'group_by_column', { column: columnName })}
      </ListItemText>
    </MenuItem>
  );
};

export default GeneratikTableColumnMenuGroupItem;
